webpackJsonp([55702396619907],{

/***/ 365:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"group":[{"fieldValue":"brewing","totalCount":1},{"fieldValue":"chemex","totalCount":1},{"fieldValue":"flavor","totalCount":2},{"fieldValue":"green beans","totalCount":1},{"fieldValue":"jamaica","totalCount":1},{"fieldValue":"tasting","totalCount":2}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-d30652bf2f00b08c279a.js